

<body class="mat-app-background">
    ADMIN

    <mat-tab-group [selectedIndex]="selectedTab" (selectedTabChange)="onTabChange($event)">
        <mat-tab label="Datos">

    <div class="row">
        <div class="col-3">
            
            <mat-form-field>
                <mat-label>Seleccione Mercado</mat-label>
                <mat-select [(ngModel)]="selectedValue2" name="food" (selectionChange)="buscarCompania2()">
                    <mat-option *ngFor="let merc of mercado" [value]="merc.idmercado"

                        [class.mat-selected]="merc.idmercado === selectedValue2"
                        [class.first-option]="true">{{merc.iso}} ({{merc.activos}})</mat-option>
                </mat-select>
            </mat-form-field>

            <button mat-raised-button color="primary" (click)="descargarDatos(selectedValue2)"
                [disabled]="!selectedValue2">
                Descargar Datos
            </button>
            <button mat-raised-button color="primary" (click)="buscarConid()" [disabled]="!selectedValue2">
                Descargar Conid
            </button>
           

        </div>
        <div class="col-3">
            <button mat-raised-button color="primary" (click)="syncCompaniaLista()">Sincronizar CompaniaLista</button>
        <button mat-raised-button color="primary" (click)="syncCompania()" class="ms-2">
        Sincronizar Companias
        </button>
        </div>
        
        <div class="col-3">
            <div class="col-md-6">
                <mat-form-field>
                    <mat-label>Ingrese Mercado</mat-label>
                    <input matInput [(ngModel)]="marketInput" name="marketInput" placeholder="Ej: AMEX">
                </mat-form-field>
            </div>
            <div class="col-md-6">
                <button mat-raised-button color="primary" (click)="buscarMercado()" [disabled]="!marketInput">
                    Buscar Mercado
                </button>
            </div>
        </div>
        <div class="col-3">
            <div class="col-3">
                <mat-form-field>
                    <mat-label>Ingrese Símbolo del Contrato</mat-label>
                    <input matInput [(ngModel)]="contractSymbol" name="contractSymbol" placeholder="Ej: AAPL">
                </mat-form-field>
            </div>
            <div class="col-3">
                <button mat-raised-button color="primary" (click)="buscarContrato()" [disabled]="!contractSymbol">
                    Buscar Contrato
                </button>
            </div>
        </div>
        <div class="col-3">
            <div class="col-3">
                <mat-form-field>
                    <mat-label>Ingrese Símbolo de la Moneda</mat-label>
                    <input matInput [(ngModel)]="currencySymbol" name="currencySymbol" placeholder="Ej: USD">
                </mat-form-field>
            </div>
            <div class="col-3">
                <button mat-raised-button color="primary" (click)="buscarMoneda()" [disabled]="!currencySymbol">
                    Buscar Moneda
                </button>
            </div>
        </div>
        <div class="col-3">
            <br>
            <label>Fecha de ultima cotizacion: {{latestDate}}</label>
            <button mat-raised-button color="primary" (click)="descargarDatosAPI()">
                Descargar Datos API
            </button>
        </div>
        
    </div>
</mat-tab>
<mat-tab label="Condiciones">
    <div class="row">
        <div class="col-3">
            <button mat-raised-button color="primary" (click)="descargarCondicionesJson()">
                Actualizar condiciones json
            </button>
        </div>
        <div class="col-3">
            <button mat-raised-button color="primary" (click)="verificarCondicionesJson()">
                Verificar condiciones json
            </button>
        </div>
        <!-- Add more content for the "Condiciones" tab as needed -->


    </div>

    <div class="row">

<div class="p-3">
    <!-- Filtro y botones existentes -->
    <div class="row mb-3">
        <!-- Filtro por nombre -->
        <div class="col-6">
            <mat-form-field class="w-100">
                <mat-label>Filtrar por Indicador o Detalle</mat-label>
                <input matInput (keyup)="aplicarFiltro($event)" placeholder="Buscar indicador o detalle...">
                <mat-icon matSuffix>search</mat-icon>
            </mat-form-field>
        </div>
        <div class="col-3">
            <button mat-raised-button color="accent" (click)="cargarCondiciones()">
                <mat-icon>refresh</mat-icon>
                Cargar Condiciones
            </button>
        </div>
        <div class="col-3">
            <button mat-raised-button color="primary" (click)="abrirDialogoNuevaCondicion()">
                <mat-icon>add</mat-icon>
                Nueva Condición
            </button>
        </div>
    </div>

    <!-- Loading indicator -->
    <div *ngIf="isLoadingCondiciones" class="mb-3">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>

    <!-- Tabla mejorada con virtual scroll -->
    <div class="table-container mat-elevation-z8">
        <!-- Cabecera fija de tabla -->
        <div class="table-header">
            <div class="header-row">
                <div class="header-cell id-column">ID</div>
                <div class="header-cell indicator-column">Indicador</div>
                <div class="header-cell detail-column">Detalle</div>
                <div class="header-cell checkbox-column">Verificado</div>
                <div class="header-cell checkbox-column">Verificado Auto</div>
                <div class="header-cell checkbox-column">Ratio</div>
                <div class="header-cell checkbox-column">Explosión Precio</div>
                <div class="header-cell actions-column">Acciones</div>
            </div>
        </div>

        <!-- Cuerpo de tabla con scroll virtual -->
        <cdk-virtual-scroll-viewport class="virtual-scroll-viewport" [itemSize]="24" [minBufferPx]="480" [maxBufferPx]="960">
            <ng-container *cdkVirtualFor="let element of dataSourceCondicionesFiltrado.data; let i = index; trackBy: trackByFn">
                <div class="data-row" [ngClass]="{'alternate-row': i % 2 === 0}">
                    <div class="data-cell id-column">{{element.idindicador}}</div>
                    <div class="data-cell indicator-column">{{element.indicador}}</div>
                    <div class="data-cell detail-column">{{element.detalle}}</div>
                    <div class="data-cell checkbox-column">
                        <mat-checkbox 
                            [checked]="element.verificado" 
                            (change)="actualizarEstado(element, 'verificado', $event.checked)"
                            [disabled]="isLoadingCondiciones">
                        </mat-checkbox>
                    </div>
                    <div class="data-cell checkbox-column">
                        <mat-checkbox 
                            [checked]="element.verificadoauto" 
                            (change)="actualizarEstado(element, 'verificadoauto', $event.checked)"
                            [disabled]="isLoadingCondiciones">
                        </mat-checkbox>
                    </div>
                    <div class="data-cell checkbox-column">
                        <mat-checkbox 
                            [checked]="element.ratio" 
                            (change)="actualizarEstado(element, 'ratio', $event.checked)"
                            [disabled]="isLoadingCondiciones">
                        </mat-checkbox>
                    </div>
                    <div class="data-cell checkbox-column">
                        <mat-checkbox 
                            [checked]="element.explosionprecio" 
                            (change)="actualizarEstado(element, 'explosionprecio', $event.checked)"
                            [disabled]="isLoadingCondiciones">
                        </mat-checkbox>
                    </div>
                    <div class="data-cell actions-column">
                        <button mat-icon-button color="primary" (click)="editarCondicion(element)" matTooltip="Editar">
                            <mat-icon>edit</mat-icon>
                        </button>
                        <button mat-icon-button color="warn" (click)="eliminarCondicion(element)" matTooltip="Eliminar">
                            <mat-icon>delete</mat-icon>
                        </button>
                    </div>
                </div>
            </ng-container>
        </cdk-virtual-scroll-viewport>
    </div>
</div>
        
    </div>
</mat-tab>
<mat-tab label = "Auditar Companias">
  <div class="p-3">
    <!-- Add control buttons -->
     <label>Auditar Companias, para revisar si se tiene picos de mas de 100 %</label>
    <div class="mb-3">
      <button mat-raised-button 
              color="primary" 
              (click)="startAuditProcess()" 
              [disabled]="isLoading"
              class="me-2">
        <mat-icon>play_arrow</mat-icon>
        Iniciar Auditoría
      </button>
      
      <button mat-raised-button 
              color="warn" 
              (click)="stopAuditProcess()" 
              [disabled]="!isLoading">
        <mat-icon>stop</mat-icon>
        Detener Auditoría
      </button>
       <button mat-raised-button 
          color="warn" 
          (click)="deleteSelected()" 
          [disabled]="!selection.hasValue()"
          class="ms-2">
    <mat-icon>delete</mat-icon>
    Eliminar Seleccionadas ({{selection.selected.length}})
  </button>
   <button mat-raised-button 
          color="primary" 
          (click)="redownloadSelected()" 
          [disabled]="!selection.hasValue()"
          class="ms-2">
    <mat-icon>refresh</mat-icon>
    Redescargar Seleccionadas ({{selection.selected.length}})
  </button>
<button mat-raised-button 
              color="accent" 
              (click)="buscarDuplicados()" 
              [disabled]="isLoading"
              class="ms-2">
        <mat-icon>find_in_page</mat-icon>
        Buscar Duplicados
      </button>    
</div>

    <!-- Loading indicator -->
    <div *ngIf="isLoading" class="mb-3">
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>

    <!-- Existing table -->
    <div class="table-container mat-elevation-z8">
      <table mat-table [dataSource]="dataSource" class="w-100">
        <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef>
            <mat-checkbox (change)="$event ? masterToggle() : null"
                        [checked]="selection.hasValue() && isAllSelected()"
                        [indeterminate]="selection.hasValue() && !isAllSelected()">
            </mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let row">
            <mat-checkbox (click)="$event.stopPropagation()"
                        (change)="$event ? selection.toggle(row) : null"
                        [checked]="selection.isSelected(row)">
            </mat-checkbox>
        </td>
        </ng-container>
      <!-- Counter Column -->
      <ng-container matColumnDef="counter">
        <th mat-header-cell *matHeaderCellDef> # </th>
        <td mat-cell *matCellDef="let element; let i = index"> {{i + 1}} </td>
      </ng-container>

      <!-- ISO Column -->
      <ng-container matColumnDef="iso">
        <th mat-header-cell *matHeaderCellDef> ISO </th>
        <td mat-cell *matCellDef="let element"> {{element.iso}} </td>
      </ng-container>

      <!-- ID Nectum Column -->
      <ng-container matColumnDef="idnectum">
        <th mat-header-cell *matHeaderCellDef> ID Nectum </th>
        <td mat-cell *matCellDef="let element"> {{element.idnectum}} </td>
      </ng-container>

      <!-- Variaciones Column -->
      <ng-container matColumnDef="variaciones">
        <th mat-header-cell *matHeaderCellDef> Variaciones </th>
        <td mat-cell *matCellDef="let element"> {{formatVariaciones(element.variacions)}} </td>
      </ng-container>

      <!-- Actions Column -->
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef> Acciones </th>
        <td mat-cell *matCellDef="let element">
          <button mat-icon-button color="primary" (click)="verGrafica(element, 0)" matTooltip="Ver gráfica">
            <mat-icon>show_chart</mat-icon>
          </button>
           <button mat-icon-button color="primary" (click)="verGrafica(element, 1)" matTooltip="Ver en la api">
            <mat-icon>show_chart</mat-icon>
          </button>
          <button mat-icon-button color="warn" (click)="borrarCompania(element)" matTooltip="Borrar compañía">
            <mat-icon>delete</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
    </div>
  </div>


</mat-tab>

<mat-tab label="Usuarios">
    <app-admin-usuario
      [isLoadingUsuarios]="isLoadingUsuarios"
      [dataSourceUsuarios]="dataSourceUsuarios"
      [displayedColumnsUsuarios]="displayedColumnsUsuarios"
      (recargarUsuarios)="cargarUsuarios()"
      (ajustarDias)="ajustarValidDays($event.usuario, $event.delta)"
      (eliminarUsuario)="eliminarUsuario($event)">
    </app-admin-usuario>
</mat-tab>

<mat-tab label="MetaAPI">
  <div class="row p-3">

    <!-- Credenciales compartidas -->
    <div class="col-12 mb-2"><h5>Credenciales MetaAPI</h5></div>
    <div class="col-4">
      <mat-form-field class="w-100">
        <mat-label>Account ID</mat-label>
        <input matInput [(ngModel)]="metaapiAccountId" placeholder="Ej: bc353f65-5b3e-...">
      </mat-form-field>
    </div>
    <div class="col-2">
      <mat-form-field class="w-100">
        <mat-label>Tipo Broker</mat-label>
        <mat-select [(ngModel)]="specTipoBroker">
          <mat-option value="METAAPI">METAAPI</mat-option>
          <mat-option value="IBKR">IBKR</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <mat-divider class="col-12 my-3"></mat-divider>

    <!-- Descarga por símbolo individual -->
    <div class="col-12 mb-2"><h6>Descargar especificación por símbolo</h6></div>
    <div class="col-3">
      <mat-form-field class="w-100">
        <mat-label>Símbolo</mat-label>
        <input matInput [(ngModel)]="metaapiSymbol" placeholder="Ej: EURUSD">
      </mat-form-field>
    </div>
    <div class="col-3 d-flex align-items-center">
      <button mat-raised-button color="primary"
              (click)="descargarSpecificacion()"
              [disabled]="!metaapiAccountId || !metaapiSymbol || specLoading">
        <mat-icon>download</mat-icon>
        {{ specLoading ? 'Descargando...' : 'Descargar Especificación' }}
      </button>
    </div>
    <div class="col-12 mt-2" *ngIf="specResult">
      <mat-card>
        <mat-card-header><mat-card-title>Resultado</mat-card-title></mat-card-header>
        <mat-card-content>
          <pre style="font-size:12px; max-height:300px; overflow:auto;">{{ specResult | json }}</pre>
        </mat-card-content>
      </mat-card>
    </div>

    <mat-divider class="col-12 my-3"></mat-divider>

    <!-- Descarga por lista (mercado) -->
    <div class="col-12 mb-2"><h6>Descargar especificaciones por mercado (lista)</h6></div>
    <div class="col-3">
      <mat-form-field class="w-100">
        <mat-label>Seleccione Mercado</mat-label>
        <mat-select [(ngModel)]="specListMercado" name="specListMercado">
          <mat-option *ngFor="let merc of mercado" [value]="merc.idmercado">{{ merc.iso }} ({{merc.activos}})</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col-3 d-flex align-items-center">
      <button mat-raised-button color="accent"
              (click)="descargarSpecificacionesPorLista()"
              [disabled]="!metaapiAccountId || !specListMercado || specListLoading">
        <mat-icon>cloud_download</mat-icon>
        {{ specListLoading ? 'Descargando...' : 'Descargar Lista' }}
      </button>
    </div>
    <!-- Progress -->
    <div class="col-12 mt-2" *ngIf="specListLoading || specListTotal > 0">
      <mat-progress-bar
        mode="determinate"
        [value]="specListTotal > 0 ? (specListProgress / specListTotal) * 100 : 0"
        style="height:8px; border-radius:4px;">
      </mat-progress-bar>
      <small class="text-muted mt-1 d-block">
        {{ specListProgress }} / {{ specListTotal }} procesados
        <span *ngIf="specListErrors.length" class="text-danger ms-2">
          ({{ specListErrors.length }} errores)
        </span>
      </small>
    </div>

  </div>
</mat-tab>

<mat-tab label="Descarga histórico">
  <ng-template matTabContent>
    <app-admin-periodos-historico></app-admin-periodos-historico>
  </ng-template>
</mat-tab>

<mat-tab label="IA">
  <ng-template matTabContent>
    <app-admin-ia-uso></app-admin-ia-uso>
  </ng-template>
</mat-tab>
</mat-tab-group>

<!-- Diálogo para Nueva/Editar Condición simplificado -->
<ng-template #dialogoCondicion>
    <h2 mat-dialog-title>{{esEdicion ? 'Editar' : 'Nueva'}} Condición</h2>
    <mat-dialog-content class="simplified-dialog">
        <form [formGroup]="formCondicion" class="condicion-form">
            <!-- Campos principales -->
            <div class="form-field-row">
                <div class="field-label">Condicion</div>
                <div class="field-input">
                    <input class="form-control"  formControlName="indicadorHumano">
                    <button class="icon-button" (click)="interpretacionCondicionConIA()" [disabled]="isLoadingCondiciones">
                        <mat-icon>{{isLoadingCondiciones ? 'hourglass_empty' : 'psychology'}}</mat-icon>
                    </button>
                </div>
            </div>
            <div class="form-field-row">
                <div class="field-label">Pseudocodigo</div>
                <div class="field-input">
                    <input class="form-control" formControlName="indicador" [mentionConfig]="mentionConfig">
                    <button class="icon-button" (click)="validarCondicionConIA()" [disabled]="isLoadingCondiciones">
                        <mat-icon>{{isLoadingCondiciones ? 'hourglass_empty' : 'psychology'}}</mat-icon>
                    </button>
                </div>
            </div>
            
            <div class="form-field-row">
                <div class="field-label">Detalle</div>
                <div class="field-input">
                    <textarea class="form-control" formControlName="detalle" rows="2"></textarea>
                </div>
            </div>
            
            <!-- Sección destacada -->
            <div class="section-header">CONFIGURACIÓN CONDICIÓN</div>
            
            <div class="form-field-row">
                <div class="field-label">JSON</div>
                <div class="field-input">
                    <textarea class="form-control" formControlName="jsonData" readonly rows="3"></textarea>
                </div>
            </div>
            
            <!-- Checkboxes organizados verticalmente -->
            <div class="checkbox-section">
                <div class="checkbox-row">
                    <label class="checkbox-container">
                        <input type="checkbox" formControlName="verificado">
                        <span class="checkbox-label">Verificado</span>
                    </label>
                </div>
                
                <div class="checkbox-row">
                    <label class="checkbox-container">
                        <input type="checkbox" formControlName="verificadoauto">
                        <span class="checkbox-label">Verificado Auto</span>
                    </label>
                </div>
                
                <div class="checkbox-row">
                    <label class="checkbox-container">
                        <input type="checkbox" formControlName="ratio">
                        <span class="checkbox-label">Ratio</span>
                    </label>
                </div>
                
                <div class="checkbox-row">
                    <label class="checkbox-container">
                        <input type="checkbox" formControlName="explosionprecio">
                        <span class="checkbox-label">Explosión Precio</span>
                    </label>
                </div>
            </div>
        </form>
    </mat-dialog-content>
    <mat-dialog-actions align="end" class="action-buttons">
    <button mat-icon-button color="warn" mat-dialog-close matTooltip="Cancelar">
        <mat-icon>close</mat-icon>
    </button>
    <button mat-icon-button color="primary" 
            (click)="guardarCondicion()" 
            [disabled]="isLoadingCondiciones"
            matTooltip="{{esEdicion ? 'Actualizar' : 'Crear'}} condición">
        <mat-icon>{{esEdicion ? 'update' : 'save'}}</mat-icon>
    </button>
</mat-dialog-actions>
</ng-template>
</body>